import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import PersonalCenterModalStore from './store';

const styles = require('./index.less');

/**
 *  个人中心弹窗
 */
const PersonalCenterModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.closeCallback = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.personalCenterModalRoot)}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.title}>个人中心</div>
        <div className={styles.content}>
          <div className={styles.leftBox}>
            <div className={cx(styles.leftOption)}>个人信息</div>
            {/* <div className={styles.leftOption}>我的评论(20)</div> */}
          </div>

          <div className={styles.rightBox}>
            {/* ID项 */}
            <div className={styles.formItem}>
              <div className={styles.formLabel}>ID</div>
              <input type="text" className={styles.formInput} value="05800563" />
            </div>

            {/* 昵称输入项 */}
            <div className={styles.formItem}>
              <div className={styles.formLabel}>昵称</div>
              <input type="text" className={styles.formInput} value="Name1 名称" />
            </div>

            {/* 昵称下拉项 */}
            <div className={styles.formItem}>
              <div className={styles.formLabel}>昵称</div>
              <select className={cx(styles.formSelect1)}>
                <option value="无">无</option>
              </select>
            </div>

            {/* 出生地下拉项 */}
            <div className={styles.formItem}>
              <div className={styles.formLabel}>出生地</div>
              <select className={cx(styles.formSelect2)}>
                <option value="几廷联邦共和国">几廷联邦共和国</option>
              </select>
            </div>

            {/* 喜爱机体标签组 */}
            <div className={styles.formItem}>
              <div className={styles.formLabel}>喜爱机体</div>
              <div className={styles.tagGroup}>
                <span className={styles.tag}>卢米纳尔</span>
                <span className={styles.tag}>三角形</span>
                <span className={styles.tag}>等级</span>
                <Link className={styles.addTagBtn} />
              </div>
            </div>

            {/* 更新按钮 */}
            <Link className={styles.updateBtn}>更新个人信息</Link>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(PersonalCenterModal, PersonalCenterModalStore);
